import { RefObject } from "react";
import { useTranslation } from "react-i18next";
import { GrappleModule } from "../../interfaces/api/GrappleModule";
import { LowerBracket } from "../../interfaces/api/LowerBracket";
import { MachineFixing } from "../../interfaces/api/MachineFixing";
import { Rototilt } from "../../interfaces/api/Rototilt";
import { UpperBracket } from "../../interfaces/api/UpperBracket";
import { MachineFixingType } from "../../shared/enums/MachineFixingType";
import { ProductCategory } from "../../shared/enums/ProductCategory";
import ProductSeperator from "../Products/ProductSeperator";
import TooltipPopup from "../shared/TooltipPopup";
import MachineFixings from "./MachineFixings";
import "./MachineFixings.scss";

interface MachineFixingsProductProps {
  grappleModules: GrappleModule[];
  isNoneGrappleModuleSelected: boolean;
  lowerBrackets: LowerBracket[];
  machineFixnings: MachineFixing[];
  onGrappleModuleChange(grappleModule: GrappleModule): void;
  onLowerBracketChange(lowerBracket: LowerBracket): void;
  onMachineFixingChange(machineFixing: MachineFixing): void;
  onMachineFixingTypeChange(machineFixingType: MachineFixingType): void;
  onNoneGrapppleModuleChange(): void;
  onUpperBracketChange(upperBracket: UpperBracket): void;
  productCategory: ProductCategory;
  refGrappleModules: RefObject<HTMLDivElement>;
  refLowerBrackets: RefObject<HTMLDivElement>;
  refMachineFixingList: RefObject<HTMLDivElement>;
  refMachineFixings: RefObject<HTMLDivElement>;
  refMachineFixingsProduct: RefObject<HTMLDivElement>;
  refUpperBrackets: RefObject<HTMLDivElement>;
  selectedGrappleModule: GrappleModule;
  selectedLowerBracket: LowerBracket;
  selectedMachineFixing: MachineFixing;
  selectedMachineFixingType: MachineFixingType;
  selectedUpperBracket: UpperBracket;
  upperBrackets: UpperBracket[];
  selectedTiltrotator: Rototilt;
}

const MachineFixingsProduct = ({
  grappleModules,
  isNoneGrappleModuleSelected,
  lowerBrackets,
  machineFixnings,
  onGrappleModuleChange,
  onLowerBracketChange,
  onMachineFixingChange,
  onMachineFixingTypeChange,
  onNoneGrapppleModuleChange,
  onUpperBracketChange,
  productCategory,
  refGrappleModules,
  refLowerBrackets,
  refMachineFixingList,
  refMachineFixings,
  refMachineFixingsProduct,
  refUpperBrackets,
  selectedGrappleModule,
  selectedLowerBracket,
  selectedMachineFixingType,
  selectedMachineFixing,
  selectedUpperBracket,
  selectedTiltrotator,
  upperBrackets,
}: MachineFixingsProductProps) => {
  const { t } = useTranslation(["machinefixings"]);
  const tooltopMachinefixing = "machineFixingTooltipId";
  const infoTooltip =
    t("sfixing.sfixing") +
    "\n" +
    t("sfixing.infotext") +
    "\n\n" +
    t("qcfixing.qcfixing") +
    "\n" +
    t("qcfixing.infotext") +
    "\n\n" +
    t("directmount.directmount") +
    "\n" +
    t("directmount.infotext");
  return (
    <div ref={refMachineFixingsProduct}>
      <ProductSeperator />
      <div className="toolHeader">
        <h3>
          {t("choosemachinefixing")}
          <sup>*</sup>
        </h3>
        <div className="preline">
          <TooltipPopup text={infoTooltip} id={tooltopMachinefixing} />
        </div>
      </div>
      <MachineFixings
        grappleModules={grappleModules}
        isNoneGrappleModuleSelected={isNoneGrappleModuleSelected}
        lowerBrackets={lowerBrackets}
        machineFixings={machineFixnings}
        onGrappleModuleChange={onGrappleModuleChange}
        onLowerBracketChange={onLowerBracketChange}
        onMachineFixingChange={onMachineFixingChange}
        onMachineFixingTypeChange={onMachineFixingTypeChange}
        onNoneGrapppleModuleChange={onNoneGrapppleModuleChange}
        onUpperBracketChange={onUpperBracketChange}
        productCategory={productCategory}
        refGrappleModules={refGrappleModules}
        refLowerBrackets={refLowerBrackets}
        refMachineFixingList={refMachineFixingList}
        refMachineFixings={refMachineFixings}
        refUpperBrackets={refUpperBrackets}
        selectedGrappleModule={selectedGrappleModule}
        selectedLowerBracket={selectedLowerBracket}
        selectedMachineFixing={selectedMachineFixing}
        selectedMachineFixingType={selectedMachineFixingType}
        upperBrackets={upperBrackets}
        selectedUpperBracket={selectedUpperBracket}
        selectedTiltrotator ={selectedTiltrotator}
      />
    </div>
  );
};

export default MachineFixingsProduct;
